import {BaseView} from '../core/view';
import { LinkUtil } from '../utils/link';
import { KeyboardUtil } from '../utils/keyboard-util';
import { TrackingUtil } from "../utils/tracking";

export default BaseView.extend({

    listWrapper: undefined,
    completeList: undefined,
    activeElementLink: undefined,
    filterType: '',

    events: {
        'keyup input[type=text]': 'handleKeyboardInput',
        'click input[type=text]': 'stopPropagation',
        'click [data-filter-value]': 'onFilterClicked',
        'submit form': 'handleSubmit'
    },

    stopPropagation: function(e) {
        e.stopPropagation();
    },

    handleSubmit: function(e) {
        e.stopPropagation();
        e.preventDefault();

        if(this.activeElementLink === undefined){
            this.activeElementLink = this.$el.find('li:first a').attr('href');
        }
        LinkUtil.goToUrl(this.activeElementLink);
    },

    handleKeyboardInput: function(e) {

        switch (e.keyCode) {
            case KeyboardUtil.keyArrowDown:
                this.highlightNextElement(true);
                break;
            case KeyboardUtil.keyArrowUp:
                this.highlightNextElement(false);
                break;
            default:
                var inputElement = this.$el.find(e.currentTarget),
                    searchterm = $(inputElement).val();

                this.filterList(searchterm);
        }
    },

    highlightNextElement: function(forward) {
        var active = this.$el.find('li.active:first').removeClass('active'),
            next;

        if (active.length) {
            if (forward) {
                next = active.next();
            } else {
                next = active.prev();
            }
        } else {
            if (forward) {
                next = this.$el.find('li:first');
            } else {
                next = this.$el.find('li:last');
            }
        }

        next.addClass('active');
        this.activeElementLink = next.find('a').attr('href');
    },

    filterList: function(searchterm) {
        var searchtermLowercase = searchterm.toLowerCase();

        if (!searchterm.trim().length) {
            this.listWrapper.html(this.completeList);
        } else {
            var code = '';

            $.each(this.completeList, function(i, val) {

                var current = $(val),
                    link = current.children('a').first();

                if (~current.attr('name').indexOf(searchtermLowercase)) {
                    link.html(link.text().replace(new RegExp('(' + searchterm + ')', 'gi'), "<strong>$1</strong>"));
                    code += current.clone().wrap('<p>').parent().html();
                }

            });

            this.listWrapper.html(code);
        }
    },

    onFilterClicked: function(e) {
        TrackingUtil.throwFilterClickedEvent(this.filterType, 
            e.currentTarget.getAttribute('data-filter-value'));
    },

    initialize: function() {
        this.listWrapper = this.$el.find('ul');
        this.completeList = this.listWrapper.children().clone();
        let filterTypeElem = this.el.querySelector('[data-filter-type]');
        if (filterTypeElem) { this.filterType = filterTypeElem.getAttribute('data-filter-type'); }
    }
});
